<template>
  <div style="padding: 0 16px">
    <a-skeleton :loading="spinning" active avatar>
      <a-table :columns="columns" :pagination="pagination" :data-source="records" size="small" row-key="index" @change="handleTableChange">
        <span slot="number" slot-scope="record">{{ records.length + 1 - record.index }}</span>
        <span slot="operator" slot-scope="operator">{{ operator ? operator.nickname : '系统' }}</span>
        <span slot="operation_alias" slot-scope="text, record">
          <span v-if="record.operation_alias === '用例执行'">
            <span>
              [
              <a>TC-{{ record.value_diff.find(item => item.value === 'case_id').before }}</a>
              ]
              <br />
              {{ record.operation_alias }}
            </span>
          </span>
          <span v-else>{{ record.operation_alias }}</span>
        </span>
        <span slot="diffItem" slot-scope="record">
          <div v-for="(item, key) in record.value_diff" :key="key">
            <span v-if="item.label !== '用例ID'">{{ item.label }}</span>
          </div>
        </span>
        <span slot="before" slot-scope="record">
          <span>
            <span v-for="(item, key) in record.value_diff" :key="key">
              <div v-if="item.value === 'title'">{{ item.before || '--' }}</div>
              <div v-else-if="item.value === 'status'">
                <a-tag v-if="item.before !== null && reviewStatus[item.before]" :color="reviewStatus[item.before].color">{{ reviewStatus[item.before].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'sign_result'">
                <a-tag v-if="item.before !== null && reviewStatus[item.before]" :color="reviewStatus[item.before].color">{{ reviewStatus[item.before].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'sign_desc'">{{ item.before || '--' }}</div>
              <div v-else-if="item.value === 'story_result'">
                <a-tag v-if="item.before !== null && reviewItemResults[item.before]" :color="reviewItemResults[item.before].color">{{ reviewItemResults[item.before].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'case_result'">
                <a-tag v-if="item.before !== null && reviewItemResults[item.before]" :color="reviewItemResults[item.before].color">{{ reviewItemResults[item.before].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'reviewers'">
                <user-profiles v-if="item.before && item.before.length > 0" :value="item.before" avatar />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'review_time'">{{ item.before || '--' }}</div>
              <div v-else-if="item.value === 'description'">
                <a v-if="item.before !== null" @click="onPreview(item.before, '「变更前」描述')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'review_scope'">
                <a-badge v-if="item.before !== null" :color="reviewTypes[item.before].color" :text="reviewTypes[item.before].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'result'">
                <div v-if="item.before !== null && testCaseResults[item.before]">
                  <a-tag v-if="item.before !== 5" :color="testCaseResults[item.before].color">{{ testCaseResults[item.before].label }}</a-tag>
                  <a-tag v-else :color="testCaseResults[item.before].color" style="color: gray; width: 40px">{{ testCaseResults[item.before].label }}</a-tag>
                </div>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'case_id'" />
              <div v-else>--</div>
            </span>
          </span>
        </span>
        <span slot="after" slot-scope="record">
          <span>
            <span v-for="(item, key) in record.value_diff" :key="key">
              <div v-if="item.value === 'title'">{{ item.after || '--' }}</div>
              <div v-else-if="item.value === 'status'">
                <a-tag v-if="item.after !== null && reviewStatus[item.after]" :color="reviewStatus[item.after].color">{{ reviewStatus[item.after].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'sign_result'">
                <a-tag v-if="item.after !== null && reviewStatus[item.after]" :color="reviewStatus[item.after].color">{{ reviewStatus[item.after].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'sign_desc'">{{ item.after || '--' }}</div>
              <div v-else-if="item.value === 'story_result'">
                <a-tag v-if="item.after !== null && reviewItemResults[item.after]" :color="reviewItemResults[item.after].color">{{ reviewItemResults[item.after].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'case_result'">
                <a-tag v-if="item.after !== null && reviewItemResults[item.after]" :color="reviewItemResults[item.after].color">{{ reviewItemResults[item.after].label }}</a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'reviewers'">
                <user-profiles v-if="item.after && item.after.length > 0" :value="item.after" avatar />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'review_time'">{{ item.after || '--' }}</div>
              <div v-else-if="item.value === 'description'">
                <a v-if="item.after !== null" @click="onPreview(item.after, '「变更后」描述')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'review_scope'">
                <a-badge v-if="item.after" :color="reviewTypes[item.after].color" :text="reviewTypes[item.after].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'result'">
                <div v-if="item.after !== null && testCaseResults[item.after]">
                  <a-tag v-if="item.after !== '5'" :color="testCaseResults[item.after].color">{{ testCaseResults[item.after].label }}</a-tag>
                  <a-tag v-else :color="testCaseResults[item.after].color" style="color: gray; width: 40px">{{ testCaseResults[item.after].label }}</a-tag>
                </div>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'case_id'" />
              <div v-else>--</div>
            </span>
          </span>
        </span>
      </a-table>
    </a-skeleton>
    <preview-modal ref="previewModal" />
  </div>
</template>

<script>
import { reviewRecord } from '@/api/project/review';
import { reviewTypes, reviewStatus, testCaseResults, reviewItemResults } from '@/utils/dictionary';

import PreviewModal from '@/pages/project/components/PreviewModal';

const columns = [
  {
    title: '序号',
    width: '5%',
    align: 'center',
    scopedSlots: { customRender: 'number' }
  },
  {
    title: '操作人',
    width: '10%',
    align: 'center',
    dataIndex: 'operator',
    key: 'operator',
    scopedSlots: { customRender: 'operator' }
  },
  {
    title: '操作时间',
    width: '15%',
    align: 'center',
    key: 'created_time',
    dataIndex: 'created_time'
  },
  {
    title: '变更类型',
    width: '10%',
    align: 'center',
    key: 'operation_alias',
    // dataIndex: 'operation_alias'
    scopedSlots: { customRender: 'operation_alias' }
  },
  {
    title: '变更项',
    width: '10%',
    align: 'center',
    scopedSlots: { customRender: 'diffItem' }
  },
  {
    title: '变更前',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'before' }
  },
  {
    title: '变更后',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'after' }
  }
];

export default {
  name: 'TestPlanRecord',
  components: { PreviewModal },
  props: {
    reviewId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      columns,
      reviewTypes,
      reviewStatus,
      testCaseResults,
      reviewItemResults,
      spinning: true,
      projectId: parseInt(this.$route.params.project_id) || null,
      pagination: {
        size: 'small',
        total: 0,
        pageSize: this.$store.getters.pageSize,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: total => `共 ${total} 条`
      },
      records: [],
      recordItems: {
        name: { value: 'title', label: '评审单标题' },
        status: { value: 'status', label: '状态' },
        reviewers: { value: 'reviewers', label: '参与人' },
        description: { value: 'description', label: '描述' },
        review_scope: { value: 'review_scope', label: '评审类型' },
        review_time: { value: 'review_time', label: '计划评审时间' },
        result: { value: 'result', label: '评审结果' },
        sign_result: { value: 'sign_result', label: '会签结果' },
        sign_desc: { value: 'sign_desc', label: '会签备注' },
        item_id: { value: 'item_id', label: 'ID' },
        story_result: { value: 'story_result', label: '需求评审结果' },
        case_result: { value: 'case_result', label: '用例评审结果' }
      }
    };
  },
  computed: {
    diff() {
      return data => {
        const items = [];
        const itemKeys = Object.keys(this.recordItems);
        for (const key in data) {
          if (itemKeys.includes(key)) {
            items.push({
              ...this.recordItems[key],
              ...data[key]
            });
          }
        }
        return items;
      };
    }
  },
  created() {
    if (this.reviewId !== null) {
      this.getReviewRecord();
    }
  },
  methods: {
    getReviewRecord() {
      reviewRecord({
        review_id: this.reviewId,
        project_id: this.projectId,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.pagination.total = res.data.total;
          this.records = res.data.items.map((record, index) => {
            return {
              index: index + 1,
              ...record,
              value_diff: this.diff(record.value_diff)
            };
          });
          this.spinning = false;
        })
        .catch(() => {
          this.spinning = false;
        });
    },

    onPreview(content, title = null) {
      this.$nextTick(() => {
        this.$refs.previewModal.onOpen(content, title);
      });
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getReviewRecord();
    }
  }
};
</script>

<style lang="less" scoped>
.diff-item {
  display: block;
}

.ql-container.ql-snow {
  border: none;
}
</style>
